// extracted by mini-css-extract-plugin
export var actionButton = "_fa-t";
export var buttonContainer = "_fa-0";
export var buttonContainer2 = "_fa-1";
export var buttonSection = "_fa-2";
export var details = "_fa-3";
export var dropdownItem = "_fa-5";
export var dropdownItemsContainer = "_fa-4";
export var fileInput = "_fa-r";
export var headerButton = "_fa-6";
export var icon = "_fa-7";
export var input = "_fa-8";
export var macroListItem = "_fa-9";
export var mainContent = "_fa-a";
export var microText = "_fa-b";
export var modal = "_fa-w";
export var optionsButton = "_fa-c";
export var paperclip = "_fa-s";
export var pillContent = "_fa-d";
export var preview = "_fa-e";
export var preview2 = "_fa-f";
export var quillEditor = "_fa-q";
export var selectedMacro = "_fa-g";
export var sidebar = "_fa-h";
export var sidebarHeader = "_fa-j";
export var sidebarList = "_fa-i";
export var sidebarListItem = "_fa-k";
export var sidebarSearch = "_fa-l";
export var snoozeDurationWrapper = "_fa-v";
export var statusPillContainer = "_fa-m";
export var tagsContainer = "_fa-n";
export var unselectedMacro = "_fa-o";
export var variable = "_fa-u";
export var wrapper = "_fa-p";